import axios from 'axios';

export default class ArticleService {

    request(path) {
        return axios.get('posts/' + path);
    }

    requestArticles() {
        console.log('About to make a call');

        return axios.get('posts/markdown-index.json');
    }

}


